var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-container', {
    staticClass: "ugc-custom-checkerboard-create"
  }, [_c('custom-container', {
    staticClass: "ugc-custom-checkerboard-create-wrapper"
  }, [_c('CustomButton', {
    staticClass: "button ugc-tray-wrapper-button",
    attrs: {
      "disabled": _vm.disableButton,
      "text": _vm.imageLibraryLabel,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.clicked();
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }